export default "__VITE_ASSET__0db4e3fa__"